import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import ActionOnSessionLimitExceeded from './ActionOnSessionLimitExceeded';

const mapStateToProps = state => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default withTranslation(['administration'])(connect(mapStateToProps, null)(ActionOnSessionLimitExceeded));
